import { withBrandsListProps } from 'viewModel/brand/brandsList/withBrandsListProps';
import BrandsList from 'components/Brand/BrandsList/BrandsList';

export default withBrandsListProps(BrandsList);
